import { useDispatch } from 'react-redux'

// Actions
import { actions as profileActions } from 'modules/profile/actions'

// Components
import { Button } from '@tracklib/kit'
import { Input, Form } from 'components/form'

// Hooks
import { useProfile } from 'modules/profile/hooks'

// Types
import type { Dispatch } from 'types'

import styles from './socialsform.css'

const SocialsForm = (): JSX.Element => {
  const dispatch = useDispatch() as Dispatch
  const profile = useProfile()

  return (
    <Form
      enableReinitialize
      initialValues={{
        website: profile.website,
        instagram: profile.instagram,
        soundcloud: profile.soundcloud,
        beatstars: profile.beatstars,
        youtube: profile.youtube,
      }}
      onSubmit={data => dispatch(profileActions.updateSocials(data, profile.id))}
    >
      {({ submitButtonProps }) => (
        <>
          <h2>Socials</h2>
          <p>Add your social channels and website to be displayed on your user profile for others to see.</p>
          <div className={styles.grid}>
            <Input name="soundcloud" label="Soundcloud" type="url" placeholder="https://www.soundcloud.com/example" optional />
            <Input name="beatstars" label="Beatstars" type="url" placeholder="https://www.beatstars.com/example" optional />
            <Input name="instagram" label="Instagram" type="url" placeholder="https://www.instagram.com/example" optional />
            <Input name="youtube" label="Youtube" type="url" placeholder="https://www.youtube.com/c/example" optional />
            <Input name="website" label="Website" type="url" placeholder="Your website" optional />
          </div>
          <footer>
            <Button datatesting="submit_socials_button" {...submitButtonProps}>
              Save changes
            </Button>
          </footer>
        </>
      )}
    </Form>
  )
}

export default SocialsForm
